<template lang="pug">
  .home
    vue-headful(
      :title="title"
    )
    .home__menu
      el-row(:gutter="50" type="flex" justify="center")
        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          .financial-inputs(v-if="loaded === true")
            h2 Financial Assumptions
            financial-inputs(
              :financialAssumptionsSwitch="financialAssumptionsSwitch"
              :financialInputs="financialInputs"
              :baseCaseFinancialAssumptions="baseCaseFinancialAssumptions"
              @switchChange="financialAssumptionsSwitch = $event"
            )

          .technical-inputs(v-if="loaded === true")
            h2 Technical Assumptions
            technical-inputs(
              :technicalAssumptionsSwitch="technicalAssumptionsSwitch"
              :technicalInputs="technicalInputs"
              :baseCaseTechnicalAssumptions="baseCaseTechnicalAssumptions"
              @switchChange="technicalAssumptionsSwitch = $event"
            )

        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          h2 Outputs
          el-row
            el-col(:lg="7" :md="7" :sm="7" :xs="7")
              el-radio-group(
                v-model="viewSwitch"
                size="large"
              )
                el-radio-button(label="Table")
                el-radio-button(label="Chart")
            el-col(:lg="7" :md="7" :sm="7" :xs="7")
              el-radio-group(
                v-model="currencySwitch"
                size="large"
              )
                el-radio-button(label="USD")
                el-radio-button(label="CAD")
            el-col(:lg="10" :md="10" :sm="10" :xs="10")
              el-radio-group(
                v-model="accountingSwitch"
                size="large"
              )
                el-radio-button(label="By-Product")
                el-radio-button(label="Co-Product")
          .table(
            v-if="viewSwitch === 'Table'"
          )
            el-table(
              v-loading="tableLoading"
              element-loading-text="Loading..."
              :data="tableData"
            )
              el-table-column(
                prop="field"
                width="150"
              )
              el-table-column(
                prop="units"
                label="Unit"
              )
              el-table-column(
                prop="baseCase"
                label="Base Case"
              )
              el-table-column(
                prop="spotCase"
                label="Spot Case"
              )
              el-table-column(
                prop="userCase"
                label="User Case"
              )

          .charts(
            v-if="viewSwitch === 'Chart'"
          )
              h3 Production and Costs
              .production-chart(v-if="loaded===true")
                production-chart(
                  height=300
                  :data="userCase.years"
                  :aiscChartField="aiscChartField"
                  :exchangeRate="exchangeRate"
                )
              h3 After-Tax Cash Flow
              .cash-flow-chart(v-if="loaded===true")
                cash-flow-chart(
                  height=300
                  :data="userCase.years"
                  :exchangeRate="exchangeRate"
                )
</template>

<script>
import Slider from '@/components/slider'
import CashFlowChart from '../components/CashFlowChart'
import ProductionChart from '../components/ProductionChart'
import TechnicalInputs from '../components/TechnicalInputs'
import FinancialInputs from '../components/FinancialInputs'
import modelMixin from '../mixins/modelMixin'

export default {
  name: 'Model',
  components: { TechnicalInputs, FinancialInputs, CashFlowChart, ProductionChart, Slider },
  mixins: [modelMixin],
  data: function () {
    return {}
  }
}
</script>

<style scoped>
.tooltip {
  font-family: sans-serif;
}

.home {
  background-color: white;
}

.home p {
  margin-bottom: 0px !important;
}

.home h1 {
  font-size: 40px;
  margin-bottom: 0px;
}

.home h2 {
  font-size: 21px;
  font-weight: bold;
  margin-top: 17.4px !important;
  margin-bottom: 17.4px !important;
}

.home h3 {
  font-size: 20px;
}

.home h4 {
  color: #555;
  font-weight: 100;
  font-size: 21px;
  margin-top: 6px;
}

.home__menu {
  font-size: 13px;
  line-height: 16px;
  background-color: white;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.03);
  z-index: 12;
}

.home__menu p,
.home__menu b {
  margin: 0px;
}

.home__menu b {
  float: right;
}

.home .el-radio-group {
  margin-bottom: 10px;
  margin-right: 5px;
}

@media screen and (max-width: 1366px) {
  .tooltip {
    display: none;
  }
}
</style>
